import { Button, ButtonGroup } from '@chakra-ui/react'
import { useMiniCalendar } from '../../../../contexts/MiniCalendarContext/Provider'

export default function DaysButtons() {
  const { setActiveDay, period } = useMiniCalendar()

  if (period) {
    return (
      <ButtonGroup size="xs" isAttached variant="outline">
        <Button size="xs" variant="outline" onClick={() => setActiveDay(Date.now())}>
          Hoje
        </Button>
        {period?.start && (
          <Button size="xs" variant="outline" onClick={() => setActiveDay(period.start || 0)}>
            Início do período
          </Button>
        )}
        {period?.final && (
          <Button size="xs" variant="outline" onClick={() => setActiveDay(period.final || 0)}>
            Final do período
          </Button>
        )}
      </ButtonGroup>
    )
  }

  return (
    <Button size="xs" variant="outline" onClick={() => setActiveDay(Date.now())}>
      Hoje
    </Button>
  )
}
